import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { EnvService } from '../_servicos/env.service';
import { FotoService } from '../_servicos/foto.service';

@Component({
  selector: 'app-sair',
  templateUrl: './sair.component.html',
  styleUrls: ['./sair.component.scss'],
})
export class SairComponent implements OnInit, AfterViewInit {
  mensagem = 'desconectando...';
  constructor(
    private readonly keycloak: KeycloakService,
    private router: Router,
    private toast: ToastrService,
    private _sFoto: FotoService,
    private _sEnv: EnvService
  ) {}

  ngOnInit() {
    this.keycloak.logout();
    this._sEnv.encerrarTimers();
    this._sFoto.removeFoto(this._sEnv.servidor.nrMatricula);
    setTimeout(() => {
      this.mensagem = '';
    }, 2000);
  }

  ngAfterViewInit() {
    setTimeout(
      () =>
        this.toast
          .success('Você foi desconectado com sucesso', 'SAIR')
          .onHidden.pipe(take(1))
          .subscribe(() => this.router.navigate(['/inicio']))
      //.subscribe(() => this.router.navigate(['/login']))
    );
  }
}
